import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutState } from "./autogen/AutogenLayoutState";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

export class State extends AutogenLayoutState {

    override onLoad(): void | Promise<void> {
        this.validateStateRecordExist();
    }

    private validateStateRecordExist() {
        const stateScreenUrl = "lme/dispatch/State?mode=update&key=";
        const validateProps: DuplicateIdProps = { tableName: "state", screenName: "State", navigateToUrl: stateScreenUrl };
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }

    textboxCountryIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }

}
